import React from 'react';
import ZendeskFAQsContainer from 'components/activity/help/zendeskFAQs/containers/ZendeskFAQsContainer';

const Help = () => {
    return <ZendeskFAQsContainer />;
};

export default Help;
